import { render, staticRenderFns } from "./bank-column.vue?vue&type=template&id=c0f6031c"
import script from "./bank-column.vue?vue&type=script&lang=js"
export * from "./bank-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports